export const minDateDefault: Date = (() => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 20);
  date.setMonth(0, 1);
  return date;
})();
